// extracted by mini-css-extract-plugin
export var marginNegative = "_5s-5 _5s-3 _5s-1";
export var marginPositive = "_5s-4 _5s-3 _5s-1";
export var modalContent = "_5s-6";
export var samplesTable = "_5s-8";
export var samplesTableContainer = "_5s-7";
export var statBox = "_5s-a";
export var tableCell = "_5s-1";
export var tableCellCenter = "_5s-2 _5s-1";
export var tableCellRight = "_5s-3 _5s-1";
export var tableHeader = "_5s-0";
export var trackingNumber = "_5s-9";